import './App.css';
import Navbar from './components/Navbar';
import About from './components/About';
import { useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import NoteState from './context/notes/noteState';
import Home from './components/Home';
import LogIn from './components/LogIn';
import SignUp from './components/SignUp';
import LoadingBar from 'react-top-loading-bar'


function App() {

  const [progress, setprogress] = useState(0);
  const [inputText, setInputText] = useState("");
  const search = (e) => {
    var text = e.target.value.toLowerCase();
    setInputText(text);
  }

  return (
    <>
      <NoteState setprogress={setprogress}>
        <Router>
          <Navbar title="Notes." search={search} Page1="Your Notes" setprogress = {setprogress}/>
          <LoadingBar
            color='#f11946'
            progress = {progress}
          />
          <Routes>
            <Route exact path="/about" element={<About input={inputText} setprogress = {setprogress} />} />
            <Route exact path="/login" element={<LogIn setprogress = {setprogress} />} />
            <Route exact path="/signUp" element={<SignUp setprogress = {setprogress} />} />
            <Route exact path="/" element={<Home input={inputText} />} />
          </Routes>
        </Router>
      </NoteState>
    </>
  );
}

export default App;
